<template>
  <div class="p-3 px-lg-4">
    <!-- <h6 class="mb-4">Установленные устройства</h6> -->
    <div class="d-flex flex-wrap">
      <div
        v-for="device in $store.state.devices"
        :key="device.id"
        class="device-card mx-2">
        <div class="card shadow-sm mb-4">
          <div class="card-header p-2 position-relative">
            <div class="position-absolute top-0 right-0">
              <button class="btn btn-sm py-1" @click="copy($event, device)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                </svg>
              </button>
              <br>
              <button class="btn btn-sm py-1" @click="$toasted.error(t.notifDeveloped)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                </svg>
              </button>
            </div>
            <router-link :to="{name: 'Device', params: {id: device.id}}" class="text-reset hover-no-decoration">
              {{ ['heat_flow_pipe', 'heat_return_pipe'].includes(device.device_type) ?
                (lang === 'ru' ? 'Теплосчетчик' : 'Теплолічильник')
                :
                (lang === 'ru' ? 'Неизвестное устройство' : 'Невідомий пристрій')
              }}
              <div class="text-warning">
                {{ device.man }}, № {{ device.serial_number }}
              </div>
              <div class="flh-100" v-if="device.apartment && device.apartment.object">
                <small>{{ lang === 'ru' ? 'Смонтированный по адресу' : 'Змонтований за адресою'}}:</small>
                <br>
                <div class="">
                  <small>{{
                    lang === 'ru' ?
                    `${device.apartment.object.name } кв. ${device.apartment.apartment_number}`
                    :
                    `${device.apartment.object.name_ua } кв. ${device.apartment.apartment_number_ua}`
                  }}</small>
                </div>
              </div>
            </router-link>
          </div>
          <div class="card-body p-2">
            <div class="row">
              <div class="col-5">{{ lang === 'ru' ? 'Суммарно' : 'Сумарно' }} Q:</div>
              <div class="col-3 text-nowrap">{{ formatNumber(device.data_last.e) }} Гкал</div>
              <div class="col-4 text-nowrap">
                <span v-if="!device.editingETotal" @click="editLimit(device, 'e_total')" style="cursor: pointer; font-size: 12px;" :style="getLimitColor(device.data_last.e, device.e_total_limit)">
                  {{ device.e_total_limit ? 'lim ' + formatLimit(device.e_total_limit) : 'lim ∞' }}
                </span>
                <input v-else type="text" v-model="device.e_total_limit_edit" @input="filterNumericInput($event, device, 'e_total')" @blur="saveLimit(device, 'e_total')" @keyup.enter="saveLimit(device, 'e_total')" class="form-control form-control-sm" style="font-size: 12px;" />
              </div>
            </div>
            <hr class="my-1">
            <div class="row">
              <div class="col-5 text-nowrap">{{ lang === 'ru' ? 'С начала месяца' : 'З початку місяця' }} Q:</div>
              <div class="col-3 text-nowrap">{{ formatNumber(device.de_month) }} Гкал</div>
              <div class="col-4 text-nowrap">
                <span v-if="!device.editingEMonth" @click="editLimit(device, 'e_month')" style="cursor: pointer; font-size: 12px;" :style="getLimitColor(device.de_month, device.e_month_limit)">
                  {{ device.e_month_limit ? 'lim ' + formatLimit(device.e_month_limit) : 'lim ∞' }}
                </span>
                <input v-else type="text" v-model="device.e_month_limit_edit" @input="filterNumericInput($event, device, 'e_month')" @blur="saveLimit(device, 'e_month')" @keyup.enter="saveLimit(device, 'e_month')" class="form-control form-control-sm" style="font-size: 12px;" />
              </div>
            </div>
            <hr class="my-1">
            <div class="row">
              <div class="col-5">{{ lang === 'ru' ? 'Суммарно' : 'Сумарно' }} V:</div>
              <div class="col-3 text-nowrap">{{ formatNumber(device.data_last.v) }} м³</div>
              <div class="col-4 text-nowrap">
                <span v-if="!device.editingVTotal" @click="editLimit(device, 'v_total')" style="cursor: pointer; font-size: 12px;" :style="getLimitColor(device.data_last.v, device.v_total_limit)">
                  {{ device.v_total_limit ? 'lim ' + formatLimit(device.v_total_limit) : 'lim ∞' }}
                </span>
                <input v-else type="text" v-model="device.v_total_limit_edit" @input="filterNumericInput($event, device, 'v_total')" @blur="saveLimit(device, 'v_total')" @keyup.enter="saveLimit(device, 'v_total')" class="form-control form-control-sm" style="font-size: 12px;" />
              </div>
            </div>
            <hr class="my-1">
            <div class="row">
              <div class="col-5 text-nowrap">{{ lang === 'ru' ? 'С начала месяца' : 'З початку місяця' }} V:</div>
              <div class="col-3 text-nowrap">{{ formatNumber(device.dv_month) }} м³</div>
              <div class="col-4 text-nowrap">
                <span v-if="!device.editingVMonth" @click="editLimit(device, 'v_month')" style="cursor: pointer; font-size: 12px;" :style="getLimitColor(device.dv_month, device.v_month_limit)">
                  {{ device.v_month_limit ? 'lim ' + formatLimit(device.v_month_limit) : 'lim ∞' }}
                </span>
                <input v-else type="text" v-model="device.v_month_limit_edit" @input="filterNumericInput($event, device, 'v_month')" @blur="saveLimit(device, 'v_month')" @keyup.enter="saveLimit(device, 'v_month')" class="form-control form-control-sm" style="font-size: 12px;" />
              </div>
            </div>
            <hr class="my-1" v-if="device.apartment && device.apartment.object">
            <div class="row" v-if="device.apartment && device.apartment.object">
              <div class="col-5 text-nowrap">{{ lang === 'ru' ? 'К оплате с нач. мес.' : 'До оплати з поч. міс.' }}:</div>
              <div class="col-3 text-nowrap">{{ formatCurrency(device.apartment.object.heat_tariff * device.de_month) }}</div>
              <div class="col-4 text-nowrap">
                <span v-if="!device.editingPayment" @click="editLimit(device, 'payment')" style="cursor: pointer; font-size: 12px;" :style="getLimitColor(device.apartment.object.heat_tariff * device.de_month, device.payment_limit)">
                  {{ device.payment_limit ? 'lim ' + formatPaymentLimit(device.payment_limit) : 'lim ∞' }}
                </span>
                <input v-else type="text" v-model="device.payment_limit_edit" @input="filterNumericInput($event, device, 'payment')" @blur="saveLimit(device, 'payment')" @keyup.enter="saveLimit(device, 'payment')" class="form-control form-control-sm" style="font-size: 12px;" />
              </div>
            </div>
            <hr class="my-1">
            <div class="row">
              <div class="col-5">Статус:</div>
              <div class="col-7">{{ device.data_last.status_field === 'NoError' ? (lang === 'ru' ? 'Исправен' : 'Справний') : (lang === 'ru' ? 'Неисправен' : 'Несправний') }}</div>
            </div>
            <hr class="my-1">
            <div class="row">
              <div class="col-5">Обновлено:</div>
              <div class="col-7">{{ device.data_last.date_time_of_request | moment('from') }}</div>
            </div>
            <hr class="my-1" v-if="device.apartment && device.apartment.object">
            <small class="font-weight-bold" v-if="device.apartment && device.apartment.object">
              {{ lang === 'ru' ? '"К оплате с начала месяца" является ориентировочной суммой согласно установленного тарифа' : '"До cплати з початку місяця" є орієнтовною сумою згідно з встановленим тарифом' }}
              {{ device.apartment.object.heat_tariff }}
              {{ lang === 'ru' ? 'грн. за 1 Гкал без учета оплаты за МЗК' : 'грн. 1 Гкал без урахування оплати за МЗК' }}.
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '../api'

export default {
  name: 'Devices',

  computed: {
    lang () {
      return this.$store.state.lang
    },
    locale () {
      return this.lang === 'ru' ? 'ru-RU' : 'ua-UA'
    },
    t () {
      return this.$store.state.i18n[this.lang]
    }
  },

  methods: {
    formatNumber (value) {
      return new Intl.NumberFormat(this.locale, {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      }).format(value)
    },

    formatCurrency (value) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: 'UAH',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value)
    },

    editLimit(device, type) {
      const fieldMap = {
        'e_total': 'editingETotal',
        'e_month': 'editingEMonth',
        'v_total': 'editingVTotal',
        'v_month': 'editingVMonth',
        'payment': 'editingPayment'
      }

      this.$set(device, fieldMap[type], true)
      const fieldName = type === 'payment' ? 'payment_limit' : `${type}_limit`
      this.$set(device, `${type}_limit_edit`, device[fieldName] || '')
    },

    async saveLimit(device, type) {
      const fieldMap = {
        'e_total': 'editingETotal',
        'e_month': 'editingEMonth',
        'v_total': 'editingVTotal',
        'v_month': 'editingVMonth',
        'payment': 'editingPayment'
      }

      const value = device[`${type}_limit_edit`]
      const numValue = value === '' ? null : parseFloat(value)

      try {
        const requestField = type === 'payment' ? 'payment_limit' : `${type}_limit`
        const response = await this.$http.post(`/api/devices/${device.id}/limits`, {
          [requestField]: numValue
        }, {
          headers: {
            'X-CSRFToken': getToken('csrftoken')
          }
        })

        if (response.data.success) {
          const deviceField = type === 'payment' ? 'payment_limit' : `${type}_limit`
          device[deviceField] = numValue
          this.$toasted.success(this.lang === 'ru' ? 'Лимит обновлен' : 'Ліміт оновлено')
        }
      } catch (e) {
        this.$toasted.error(`${e.name}: ${e.message}`)
      } finally {
        this.$set(device, fieldMap[type], false)
      }
    },

    formatLimit(value) {
      if (!value) return '∞'
      return new Intl.NumberFormat(this.locale, {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
        //minimumIntegerDigits: 6,
        useGrouping: false
      }).format(value)
    },

    formatPaymentLimit(value) {
      if (!value) return '∞'
      return new Intl.NumberFormat(this.locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false
      }).format(value)
    },

    getLimitColor(current, limit) {
      if (!limit) return { color: 'black' } // черный цвет для бесконечности
      return current >= limit ? { color: 'red' } : { color: 'green' }
    },

    filterNumericInput(event, device, type) {
      const input = event.target
      let value = input.value
      
      // Разрешаем только цифры, точку и запятую
      value = value.replace(/[^\d.,]/g, '')
      
      // Заменяем запятую на точку для единообразия
      value = value.replace(/,/g, '.')
      
      // Оставляем только первую точку
      const parts = value.split('.')
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('')
      }
      
      // Обновляем значение через v-model
      this.$set(device, `${type}_limit_edit`, value)
    },

    copy (event, device) {
      event.preventDefault()
      // const text = event.target.parentElement.parentElement.parentElement.parentElement.textContent
      let text = ''
      text += ['heat_flow_pipe', 'heat_return_pipe'].includes(device.device_type) ? 'Теплосчетчик' : 'Неизвестное устройство'
      text += ` ${device.man}, № ${device.serial_number}\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `${this.lang === 'ru' ? 'Смонтированный по адресу' : 'Змонтований за адресою'}:\n`
      if (this.lang === 'ru') {
        text += `${device.apartment.object.name} кв. ${device.apartment.apartment_number}\n`
      } else {
        text += `${device.apartment.object.name_ua} кв. ${device.apartment.apartment_number_ua}\n`
      }
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `${this.lang === 'ru' ? 'Суммарно' : 'Сумарно'} Q: ${this.formatNumber(device.data_last.e)} Гкал\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `${this.lang === 'ru' ? 'С начала месяца' : 'З початку місяця'} Q: ${this.formatNumber(device.de_month)} Гкал\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `${this.lang === 'ru' ? 'Суммарно' : 'Сумарно'} V: ${ this.formatNumber(device.data_last.v) } м³\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `${this.lang === 'ru' ? 'С начала месяца' : 'З початку місяця'} V: ${this.formatNumber(device.dv_month) } м³\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `${this.lang === 'ru' ? 'К оплате с начала месяца' : 'До оплати з початку місяця'}: ${this.formatCurrency(device.apartment.object.heat_tariff * device.de_month)}\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `Статус: ${ device.data_last.status_field === 'NoError' ? (this.lang === 'ru' ? 'Исправен' : 'Справний') : (this.lang === 'ru' ? 'Неисправен' : 'Несправний')}\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      text += `Обновлено: ${this.$moment(device.data_last.date_time_of_request).fromNow()}\n`
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      if (this.lang === 'ru') {
        text += `"К оплате с начала месяца" является ориентировочной \nсуммой согласно установленного тарифа \n${device.apartment.object.heat_tariff} грн. за 1 Гкал без учета оплаты за МЗК.\n`
      } else {
        text += `"До cплати з початку місяця" є орієнтовною сумою \nзгідно з встановленим тарифом \n${device.apartment.object.heat_tariff} грн. 1 Гкал без урахування оплати за МЗК.\n`
      }
      text += '- - - - - - - - - - - - - - - - - - - - - - - -\n'
      this.$toasted.info(this.lang === 'ru' ? 'Скопировано' : 'Скопійовано')
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      }
      else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    }
  },

  async mounted () {
    // Редирект суперадмина на страницу управления
    if (this.$store.state.user.is_superuser) {
      this.$router.push('/manage/groups')
      return
    }
    
    // Данные загружаются глобально в App.vue, поэтому здесь не нужно загружать их повторно
    // Компонент Devices.vue используется только для отображения, данные уже должны быть загружены
  }
}
</script>

<style media="screen" lang="scss">
// @media (max-width: 576px) {
.device-card {
  .card-body{
    font-size: 14px;
  }
}
// }

</style>
